import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import fr.xibalba.generateurClassesLycee.components.layouts.Navbar as _fr_xibalba_generateurClassesLycee_components_layouts_Navbar
import fr.xibalba.generateurClassesLycee.pages.AgencementPage as _fr_xibalba_generateurClassesLycee_pages_AgencementPage
import fr.xibalba.generateurClassesLycee.pages.ElevesPage as _fr_xibalba_generateurClassesLycee_pages_ElevesPage
import fr.xibalba.generateurClassesLycee.pages.Index as _fr_xibalba_generateurClassesLycee_pages_Index
import fr.xibalba.generateurClassesLycee.pages.NotFound as _fr_xibalba_generateurClassesLycee_pages_NotFound
import fr.xibalba.generateurClassesLycee.pages.eleves.Liste as _fr_xibalba_generateurClassesLycee_pages_eleves_Liste
import fr.xibalba.generateurClassesLycee.pages.fichier.FichierPage as _fr_xibalba_generateurClassesLycee_pages_fichier_FichierPage
import fr.xibalba.generateurClassesLycee.pages.fichier.Nettoyage as _fr_xibalba_generateurClassesLycee_pages_fichier_Nettoyage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Assistant pour la création de classes pour le lycée"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx, pageMethod -> 
            _fr_xibalba_generateurClassesLycee_components_layouts_Navbar(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_Index()
        }
        ctx.router.register(
            "/404",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_NotFound()
        }
        ctx.router.register(
            "/agencement",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_AgencementPage()
        }
        ctx.router.register(
            "/eleves",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_ElevesPage()
        }
        ctx.router.register(
            "/eleves/liste",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_eleves_Liste()
        }
        ctx.router.register(
            "/fichier/chargement",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_fichier_FichierPage()
        }
        ctx.router.register(
            "/fichier/nettoyage",
            layoutId = "fr.xibalba.generateurClassesLycee.components.layouts.Navbar",
        ) { pageCtx -> 
            _fr_xibalba_generateurClassesLycee_pages_fichier_Nettoyage()
        }

        fr.xibalba.generateurClassesLycee.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("primary-navbar", fr.xibalba.generateurClassesLycee.components.layouts.PrimaryNavbarStyle)
        ctx.theme.registerStyle("secondary-navbar", fr.xibalba.generateurClassesLycee.components.layouts.SecondaryNavbarStyle)
        ctx.theme.registerStyle("primary-button", fr.xibalba.generateurClassesLycee.components.layouts.PrimaryButtonStyle)
        ctx.theme.registerStyle("secondary-button", fr.xibalba.generateurClassesLycee.components.layouts.SecondaryButtonStyle)
        ctx.theme.registerStyle("brand", fr.xibalba.generateurClassesLycee.components.layouts.BrandStyle)
        fr.xibalba.generateurClassesLycee.initSilk(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        fr.xibalba.generateurClassesLycee.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
